<template>
	<div>
		<span>
			{{ label }} = 
		</span>
		<span :class="currentRatio > contrastThreshold ? 'text-success' : 'text-danger'">
			{{ numberFormatter.format(currentRatio) }}
			<i class="fa" :class="currentRatio > contrastThreshold ? 'fa-check-circle' : 'fa-times-circle'"></i>
		</span>
	</div>
</template>

<script>
	import colorContrast from 'color-contrast'
	import {numberFormatter} from "../../lib/utility.js";

	export default{
		name: 'VContrastCheck',
		props: {
			fontColor: {
				type: [String],
				required: false,
				default: "#ffffff"
			},
			backgroundColor: {
				type: [String],
				required: false,
				default: "#000000"
			},
			contrastThreshold: {
				type: Number,
				required: false,
				default: 4.5
			},
			label:{
				type: String,
				required: false,
				default: ""
			},
		},
		data:function(){
			return {
				numberFormatter: numberFormatter
			}
		},
		computed:{
			currentRatio: {
				get(){
					let contrast = colorContrast(this.fontColor,this.backgroundColor)

					this.$emit('rationchange', contrast)

					return contrast
				}
			}
		},
		methods: {}
	}
</script>